import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'
import { isMobile } from '@/utils/device' // 导入设备检测工具

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    component: Layout,
    redirect: '/welcome',
    children: [
      {
        path: 'welcome',
        name: 'Welcome',
        component: () => import('../views/Welcome.vue')
      },
      {
        path: 'analysis',
        name: 'Analysis',
        component: { render: h => h('router-view') },
        meta: { title: '数据', icon: 'el-icon-data-analysis' },
        redirect: '/analysis/panel',
        children: [
          {
            path: 'panel',
            name: 'DataPanel',
            component: () => import('../views/analysis/index.vue'),
            meta: { title: '数据面板' }
          },
          {
            path: 'monthly',
            name: 'MonthlyComparison',
            component: () => import('../views/analysis/components/MonthlyIndex.vue'),
            meta: { title: '月度环比分析' }
          },
          {
            path: 'wrong-analysis',
            name: 'WrongAnalysis',
            component: () => import('../views/analysis/components/WrongAnalysisIndex.vue'),
            meta: { title: '错题分析' }
          },
          {
            path: 'correction-analysis',
            name: 'CorrectionAnalysis',
            component: () => import('../views/analysis/components/CorrectionAnalysisIndex.vue'),
            meta: { title: '订正分析' }
          },
          {
            path: 'score-trend',
            name: 'ScoreTrend',
            component: () => {
              if (isMobile()) {
                return import('../views/analysis/ScoreTrendMobile.vue')
              }
              return import('../views/analysis/ScoreTrend.vue')
            },
            meta: { title: '积分趋势' }
          }
        ]
      },
      {
        path: 'game',
        name: 'Game',
        component: () => import('../views/game/index.vue')
      },
      {
        path: 'question',
        name: 'Question',
        component: () => import('../views/question/index.vue')
      },
      {
        path: 'wrongbook',
        name: 'Wrongbook',
        component: () => import('../views/wrongbook/index.vue')
      },
      {
        path: 'tag',
        name: 'Tag',
        component: () => import('../views/tag/index.vue')
      },
      {
        path: 'outline',
        name: 'Outline',
        component: () => import('../views/outline/index.vue')
      },
      {
        path: 'plan',
        name: 'Plan',
        component: () => import('../views/plan/index.vue')
      },
      {
        path: 'article',
        component: () => import('@/views/article/index.vue'),
        children: [
          {
            path: '',
            name: 'ArticleList',
            component: () => import('@/views/article/components/ArticleListIndex.vue'),
            meta: { title: '文章列表' }
          },
          {
            path: 'edit/:articleCode?',
            name: 'ArticleEdit',
            component: () => import('@/views/article/components/ArticleEdit.vue'),
            meta: { title: '编辑文章' }
          },
          {
            path: 'view/:articleCode',
            name: 'ArticleView',
            component: () => import('@/views/article/components/ArticleViewIndex.vue'),
            meta: { title: '查看文章' }
          }
        ]
      },
      {
        path: 'tools',
        name: 'Tools',
        component: { render: h => h('router-view') },
        meta: { title: '工具', icon: 'el-icon-s-tools' },
        children: [
          {
            path: 'pathfinding',
            name: 'PathFinding',
            component: () => import('../views/tools/PathFinding.vue'),
            meta: { title: '算法模拟' }
          }
        ]
      },
      {
        path: 'system',
        name: 'System',
        component: { render: h => h('router-view') },
        meta: { title: '系统管理', icon: 'el-icon-setting' },
        children: [
          {
            path: 'friend-link',
            name: 'FriendLink',
            component: () => import('../views/system/FriendLinkIndex.vue'),
            meta: { title: '友链管理' }
          },
          {
            path: 'dict',
            name: 'Dict',
            component: () => import('../views/system/DictIndex.vue'),
            meta: { title: '字典管理' }
          },
          {
            path: 'user',
            name: 'User',
            component: () => import('@/views/system/UserIndex.vue'),
            meta: { title: '用户管理' }
          },
          {
            path: 'great-event',
            name: 'GreatEvent',
            component: () => import('@/views/system/GreatEventIndex.vue'),
            meta: { title: '大事记管理' }
          }
        ]
      }
    ]
  },
  {
    path: '/blog',
    component: () => import('@/views/blog/BlogLayout.vue'),
    children: [
      {
        path: '',
        name: 'BlogHome',
        component: () => import('@/views/blog/BlogHome.vue'),
        meta: { title: '博客首页', public: true }
      },
      {
        path: 'view/:articleCode',
        name: 'BlogArticle',
        component: () => import('@/views/blog/BlogArticleIndex.vue'),
        alias: '/article/view/:articleCode',
        meta: { title: '博客文章', public: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/blog'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.getItem('token')
  // 添加公开页面的检查
  const isPublicRoute = to.matched.some(record => record.meta.public)
  
  if (to.path !== '/login' && !isLogin && !isPublicRoute) {
    next('/blog')
  } else {
    next()
  }
})

export default router 